export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-policy-paper/_ct-policy-paper.twig";